<template>
    <ListEditForm
        v-bind="$attrs"
        :form-component="JobExperienceForm"
        :new-item-generator="createDefaultJobPosition"
        new-item-label="Pridať pozíciu"
        :value="modelValue"
        @input="$emit('update:modelValue', $event)"
    />
</template>

<script setup lang="ts">
import { JobPosition, createDefaultJobPosition } from '#shared/types/User'
import JobExperienceForm from '@/components/profile/JobExperienceForm.vue'
import ListEditForm from '@/components/profile/ListEditForm.vue'

defineOptions({
    inheritAttrs: false
})

defineProps<{
    modelValue: JobPosition[]
}>()

defineEmits<{
    'update:modelValue': [value: JobPosition[]]
}>()
</script>